import React from 'react';
import CustomModal from '../mui/CustomModal';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import { CustomButton } from '../mui/CustomButton';
import CustomTypography from '../mui/CustomTypography';
import { Box } from '@mui/material';

const ConfirmationModal = ({ open, onClose, onBack, onConfirm, title = 'Alert!', bodyText = '' }) => {
  return (
    <CustomModal open={open} onClose={onClose} sx={{ maxWidth: '500px' }}>
      <div className="preview-dropdown-header">
        {title}
        <HighlightOffRoundedIcon
          onClick={onClose}
          style={{ cursor: 'pointer', opacity: 0.5, height: '28px', width: '28px' }}
        />
      </div>
      <div className="preview-dropdown-body">
        <CustomTypography>{bodyText}</CustomTypography>
      </div>
      <div>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'center',
            gap: 2,
            marginBottom: '20px',
          }}
        >
          <CustomButton variant="secondary" size="large" onClick={onBack}>
            Back
          </CustomButton>
          <CustomButton variant="secondary" size="large" onClick={onConfirm}>
            Confirm
          </CustomButton>
        </Box>
      </div>
    </CustomModal>
  );
};

export default ConfirmationModal;
